const routerArr = [
  {
      path: '/rensheGoodsList',
      name: 'rensheGoodsList',
      meta: { title:'课程',login:false },
      component: () => import(/* webpackChunkName: 'renshe_zizhu' */ './page/courseGoodsList.vue'),
  },
]
export default routerArr